import { render, staticRenderFns } from "./BrandToggleFontSizes.vue?vue&type=template&id=53c9b1d6&"
import script from "./BrandToggleFontSizes.vue?vue&type=script&lang=ts&"
export * from "./BrandToggleFontSizes.vue?vue&type=script&lang=ts&"
import style0 from "./BrandToggleFontSizes.vue?vue&type=style&index=0&id=53c9b1d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports